export enum QuestionType {
  OPEN = 1,
  SINGLE_CHOICE = 2,
  MULTIPLE_CHOICE = 3,
}
